import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.assistedClass ? 'var(--purple6a)' : 'transparent'};
  border-style: solid;
  border-width: 2px;
  border-color: var(--purple6a);
  transition: 0.2s all;
  cursor: pointer;

  @media (max-width: 1024px) {
    height: 33px;
    min-width: 33px;
    margin-right: 20px;
  }
`;
